import { useContext } from 'react';

import StringsContext from '../Contexts/StringsContext';
import { BOARD_TYPE } from '../server/constants';

import type { Board } from '../ArrivalsDeparturesBoardReducer';

import STYLES from './Heading.module.scss';

interface Props {
  selectedBoard: Board;
}

const Heading = ({ selectedBoard }: Props) => {
  const strings = useContext(StringsContext);

  return (
    <div className={STYLES.Heading}>
      <div className={STYLES.Heading__airline}>
        {strings.falcon_adb_column_airline}
      </div>
      <div className={STYLES.Heading__flightCode}>
        {strings.falcon_adb_column_flight_code}
      </div>
      <div className={STYLES.Heading__arrivalDepartureTime}>
        {selectedBoard === BOARD_TYPE.ARRIVALS
          ? strings.falcon_adb_column_arrival_time
          : strings.falcon_adb_column_departure_time}
      </div>
      <div className={STYLES.Heading__originDestination}>
        {selectedBoard === BOARD_TYPE.ARRIVALS
          ? strings.falcon_adb_column_origin
          : strings.falcon_adb_column_destination}
      </div>
      <div className={STYLES.Heading__status}>
        {strings.falcon_adb_column_status}
      </div>
      <div className={STYLES.Heading__terminalAndGate}>
        {strings.falcon_adb_column_terminal_and_gate}
      </div>
    </div>
  );
};

export default Heading;
